<template>
  <aside class="sidebar">
    <nav class="sections mb-6">
      <!-- <h5 class="sidebar__title mb-6">Разделы</h5>
      <ul class="sections__menu mb-9" :class="activeSection">
        <li
          v-for="sect in constData.sections"
          :key="sect.id"
          class="sections__item"
          :class="{ 'sidebar-item--active': sect.id === section }"
          @click="section = sect.id"
        >
          {{ sect.name }}
        </li>
      </ul> -->
    </nav>

    <BannerPlugin class="sidebar-banner" position="column" v-if="data.section_type==='buildingsmart' || data.section_type==='projects'" />

    <div class="sidebar-about" v-else>
      <h5 class="sidebar__title mb-6">О нас пишут</h5>

      <div class="reference-article" v-for="link in constData.referenceLinks" :key="link.url">

        <blockquote>{{link.text}}</blockquote>

        <p class="reference-article__source">
          Источник:
          <a class="reference-article__link" :href="link.url" rel="nofollow" target="_blank">
            {{link.title}}
            <i class="icon-external"></i>
          </a>
        </p>
      </div>
    </div>
  </aside>
</template>

<script>
import BannerPlugin from "./BannerPlugin"
export default {
  components: {
    BannerPlugin
  },
  props: {
    data: Object
  },
  data() {
    return {
      section: 'all',
      constData: {
        sections: [
          { id: 'all', name: 'Все' },
          { id: 'popular', name: 'Популярное' },
          { id: 'new', name: 'Свежее' },
          { id: 'bookmarks', name: 'Закладки' },
        ],
        referenceLinks: [
          {
            url:
              'https://vc.ru/tribuna/70868-neyroset-dlya-bystrogo-rascheta-predvaritelnoy-smety-v-stroitelstve?from=bimlib.pro',
            title: 'VC.RU',
            text: 'Нейросеть для быстрого расчёта предварительной сметы в строительстве. Российская компания представила на BIM-форуме прототип BIMLIB 2.0 — цифровую платформу для быстрого определения стоимости строительных материалов и оборудования.'
          },
          {
            url:
              'https://rusplt.ru/sub/economy/ryinke-poyavilsya-revolyutsionnyiy-36253.html?from=bimlib.pro',
            title: 'rusplt.ru',
            text: 'Специалисты компании разработали не имеющий аналогов в мире алгоритм обучения искусственной нейронной сети, который позволяет определить заложенные проектировщиком в проект материалы и доставить информацию о их стоимости и наличии в конкретном регионе прямо до рабочего места проектировщика.'
          },
        ],
      },
    }
  },
  computed: {
    /**
     * В зависимости от выбранной секции присваивает менюшке нужный класс.
     * Решение не очень удачное, нужно будет TODO: переписать на универсальную логику.
     */
    activeSection() {
      switch (this.section) {
        case 'all':
          return 'sections__menu--all'
        case 'popular':
          return 'sections__menu--popular'
        case 'new':
          return 'sections__menu--new'
        case 'bookmarks':
          return 'sections__menu--bookmarks'
      }
      return this.data
    },
  },
}
</script>
